<!-- 简历管理 -->
<template>
  <div>
    <div
      class="bg-white rounded py-[20px] px-[24px] mb-[20px] flex justify-between hover:shadow-md transition-shadow"
      v-for="(item,index) in resumeList"
      :key="item.id"
    >
      <div>
        <p class="text-[18px] font-bold mb-[5px]">简历编号：{{ item.id }}</p>
        <p class="text-[14px] text-[#b3b3b3]">最后更新时间：{{ updateTime(index) }}</p>
      </div>
      <div>
        <a :href="`resume.html#/?id=${item.id}`" target="_blank" class="mr-[20px]">
          <el-button size="small">编辑</el-button>
        </a>
        <el-popconfirm title="确认删除此简历？" @confirm="handleResumeDelete(item.id)">
          <el-button slot="reference" size="small">删除</el-button>
        </el-popconfirm>
      </div>
    </div>
    <div class="text-center">
      <a href="resume.html" target="_blank">
        <el-button class="!px-[30px]">添加新简历</el-button>
      </a>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/utils/eventbus';
import { formatDate } from '@/utils/tool';
import { resumeList, resumeDelete } from '@/api/user-center';

export default {
  name: 'AccountResumeList',
  data() {
    return {
      resumeList: [
        {
          id: '',
          name: '',
          sex: '',
          birthday: '',
          mz: '',
          hyzk: '',
          gznx: '',
          zzmm: '',
          zjlx: '',
          zjhm: '',
          province: '',
          province2: '',
          zgxl: '',
          xw: '',
          xl: '',
          bysj: '',
          byyx: '',
          zy: '',
          yddh: '',
          dayx: '',
          txdz: '',
          yb: '',
          zp: '',
          city: '',
          district: '',
          city2: '',
          district2: '',
          gj: '',
          index_user_id: '',
          delete_time: '',
          update_time: '',
        },
      ],
    };
  },
  methods: {
    // 获取简历列表
    getData() {
      resumeList().then((res) => {
        this.resumeList = res.data.list;
      });
    },
    // 删除简历
    handleResumeDelete(ids) {
      resumeDelete({ ids })
        .then((res) => {
          this.$message.success(res.msg);
          EventBus.$emit('update-count');
          this.getData();
        })
        .catch((err) => {
          this.$message.error('删除失败,' + err.msg);
        });
    },
    // 最后更新时间
    updateTime(index) {
      return formatDate(this.resumeList[index].update_time,"YYYY-MM-DD HH:mm:ss");
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
